/*
*###############################################################################
*Module Name                   : SalesReport.js                                #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  Minol Prageesha                              #
*Date                          : Wednesday, January 19th 2022, 1:53:22 pm      #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/


import React, { useState, useEffect } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,

    Container,
    Row,
    CardBody,Col, Input, Alert
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPInfoBox from 'framework/layout/DPInfoBox'
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPSwitch from 'framework/components/DPSwitch'
import DPTextBox from 'framework/components/DPTextBox'
import DPDropDown from 'framework/components/DPDropDown'
import moment from 'moment';
import DPButton from 'framework/components/DPButton'
//**End Importing required componant files */
moment().format();
const SalesReport = (props) => {


    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")

    const [start, setstart] = useState("");
    const [end, setend] = useState("");
    const [location, setlocation] = useState([])
    const reportType = [{ label: "Location Wise Sales Report", value: 1 }, { label: "Group Wise Sales Report", value: 3 }, { label: "Product Profitability Detail Report", value: 4 }, { label: "Product Profitability Summary Report", value: 6 }, { label: "Counter wise Sales Report", value: 5 }, { label: "Counter wise Sales Summary Report", value: 7 }]
    const [selectreport, setselectreport] = useState("")
    const [optionGroup, setoptionGroup] = useState([{ options: [] }]);
    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")

    //Alert Parameter
    const [ErrorMsg, setErrorMsg] = useState('')
    const [show, setShow] = useState(false);
    const [AlertMsg, setAlertMsg] = useState('');
    const [AlertColor, setAlertColor] = useState('');
    const [select, setSelectAll] = useState(false);
    const [rebuild, setRebuild] = useState(true)


    /**********End Loading Alert */

    useEffect(() => {
        const authToken = localStorage.getItem("authToken")
        var day = new Date();
        setstart(moment(day).format('YYYY-MM-DD'))
        setend(moment(day).format('YYYY-MM-DD'))

    }, [])



    var time = process.env.REACT_APP_ALERTTIMEOUT

    //  api call to suplier area
    React.useEffect(async () => {
        var requestOptions = {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        const ApiURL = window.Links.ApiURL
        await fetch(`${ApiURL}locations/select`, requestOptions)
            .then(response => response.json())
            .then(result => {
                setoptionGroup(result.data)
                let dt = result.data
            })
            .catch(error => console.log('error', error));
    }, [rebuild]);

    function handleAddRowNested(data) {
        var data = data
        const modifiedRows = [...location]
        var index = modifiedRows.indexOf(data);
        if (index > -1) {
            modifiedRows.splice(index, 1);
        }
        else {
            modifiedRows.push(data)
        }
        setlocation(modifiedRows)
    }

    function selectAll() {
        const modifiedRows = []
        optionGroup.map(item => {
            modifiedRows.push(item.value)
        })
        setlocation(modifiedRows)
    }



    // print Function
    function handleLocationstockPrint() {
        handleAddRowNested()
        setTimeout(() => {
            if (selectreport == "") {
                setAlertColor('danger')
                setAlertMsg("Please select the report Type..!")
                setShow(true)
                setTimeout(() => {
                    setShow(false)
                }, time)
                return;
            }
            else if (location.length == 0) {
                setAlertColor('danger')
                setAlertMsg("Please select the Location..!")
                setShow(true)
                setTimeout(() => {
                    setShow(false)
                }, time)
                return;
            }
            else if (start > end) {
                setAlertColor('danger')
                setAlertMsg("Please select the  Date Range Correctly..!")
                setShow(true)
                setTimeout(() => {
                    setShow(false)
                }, time)
                return;
            }
            else if (end == "") {
                setAlertColor('danger')
                setAlertMsg("Please select the End Date..!")
                setShow(true)
                setTimeout(() => {
                    setShow(false)
                }, time)
                return;
            }
            else {
                SetLoadingAlert(true)
                SetLoadingAlerttitle("Generating Report...")

                var obj = JSON.parse(localStorage.getItem("authUser"))
                var LogUserType = obj[2]
                const authToken = localStorage.getItem("authToken")
                const ReportURL = window.Links.ReportURL
                fetch(`${ReportURL}api/StockReport/report/${selectreport}/1/${start}/${end}/${location}/${LogUserType}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${authToken}`
                    }
                }).then(Response => Response.json())
                    .then(responseData => {

                        if (responseData.success == true) {
                            {
                                const msg = responseData.msg
                                setRebuild(!rebuild)
                                window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                            }
                        }
                        SetLoadingAlert(false)
                        //setlocation([])
                        //setSelectAll(false)
                    })
            }
        }, 10)
    }



    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>My Report</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title="My Report" breadcrumbItem="Sales Reports"></Breadcrumb>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>

                                    <DPLoadingAlert
                                        confirm_both={loadingAlert}
                                        title={loadingAlertTitle}
                                    />
                                    {show ? (
                                        <Alert color={AlertColor} role="alert">
                                            {AlertMsg}
                                            <br />
                                            <small>{ErrorMsg}</small>
                                        </Alert>
                                    ) : null}

                                    <Row>
                                        <Row>
                                            <Col sm={12} md={8} className="mb-4-sm">
                                                <DPDropDown
                                                    labelText="Choose the report *"
                                                    rowClass="mb-4-sm"
                                                    optionGroup={reportType}
                                                    selectedGroup={selectreport}
                                                    onChange={val5 => {
                                                        setselectreport(val5["value"])
                                                    }}
                                                />

                                            </Col>
                                            <Col sm={12} md={4} className="mb-4-sm">
                                                <Row>
                                                    <Col sm={4}>Select all Locations</Col>
                                                    <Col >
                                                        <DPSwitch
                                                            rowClass={"mb-4-sm"}
                                                            onChange={e => {
                                                                if (select == true) {
                                                                    setSelectAll(false)
                                                                    setlocation([])
                                                                } else {
                                                                    setSelectAll(true)
                                                                    selectAll()
                                                                }

                                                            }}
                                                            checked={select}
                                                            disabled={false}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>

                                        <Row>

                                            <Col sm={12} md={4} className="mb-4-sm">
                                                {/* <p>Supplier wise Stock Report</p> */}
                                                <DPTextBox
                                                    rowClass="mb-3-sm"
                                                    labelText="From Date"
                                                    textType="date"
                                                    maxLength="50"
                                                    value={start}
                                                    onChange={(e) => {
                                                        setstart((e.target.value))
                                                    }}
                                                    disabled={false} />
                                            </Col>


                                            <Col sm={12} md={4} className="mb-4-sm">
                                                <DPTextBox
                                                    rowClass="mb-4-sm"
                                                    labelText="To Date"
                                                    textType="date"
                                                    maxLength="50"
                                                    value={end}
                                                    onChange={(e) => {
                                                        setend((e.target.value))
                                                    }}
                                                    disabled={false} />
                                            </Col>

                                            <Col sm={12} md={4} className="mb-4-sm">
                                                <DPButton
                                                    text={"Generate Report"}
                                                    onClick={() => {
                                                        handleLocationstockPrint()
                                                    }}
                                                />
                                            </Col>

                                        </Row>



                                        <Col sm={12} md={2} className="mb-4-sm"></Col>
                                        <p></p>
                                        <Col sm={12} md={2} className="mb-4-sm">
                                        </Col>
                                        <Col sm={12} md={8} className="mb-4-sm">
                                            <div style={{ height: 500, overflowY: 'auto', paddingTop: '20px' }}>
                                                <table style={{ fontSize: "11px" }} id={"taxdata"} >
                                                    <thead className="table-light">
                                                        <tr>
                                                            {/* <th style={{ textAlign: "right" ,fontSize:"15px",color:"white"}}>Code </th> */}
                                                            <th style={{ fontSize: "12px", color: "white", width: "160px" }}>Location </th>
                                                            <th style={{ textAlign: "left", fontSize: "12px", color: "white" }}>Select</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody disabled={true}>
                                                        {(optionGroup || []).map((FormRow, key) => (
                                                            <tr key={FormRow.code}>
                                                                <td style={{ width: "60px" }}>
                                                                    <Row className="mb-3">
                                                                        <Col md="12">
                                                                            <label>{FormRow.label}</label>
                                                                        </Col>
                                                                    </Row>
                                                                </td>
                                                                <td style={{ width: "60px", margin: "auto" }}>
                                                                    <Row className="mb-3">
                                                                        <Col md="12" style={{ textAlign: "center" }}>
                                                                            <Input
                                                                                type="checkbox"

                                                                                onClick={() =>
                                                                                    handleAddRowNested(FormRow.value)
                                                                                }
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01T00:00:00' ? crDate : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01T00:00:00' ? mdDate : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    )

}

export default SalesReport